// extracted by mini-css-extract-plugin
module.exports = {"outdoor-recreation-J":"Other_outdoor-recreation-J__w_EgN"};